export default "__VITE_ASSET__9fad9dec__"